export default __webpack_public_path__ + "static/media/AP.d60d34ce.svg";